import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Input } from '@pwc/appkit-react/lib/Input';
import { MdControlPoint as PlusIcon, MdArrowForward as SaveIcon, MdSettings as SettingsIcon } from 'react-icons/md';
import Spinner from '../../shared/spinner.component';

import ContentButton from './contentButton.component';
import { HelpContentSettingsPopup } from '../shared/HelpContentSettings.component';
import { POPUP_CALLER_CLASS } from '../../shared/detailPopup.component';
import { ADD_HELP_SETTINGS_POPUP, ALL_CLIENTS } from '../shared/constants';

const getPopupId = (() => {
  let index = 0;
  return () => `${ADD_HELP_SETTINGS_POPUP}_${index++}`;
})();

const defaultSettings = {
  clients: [ALL_CLIENTS],
};

const AddContentButton = ({ onSubmit, loading, hideSettingsIcon }) => {
  const [showInput, setShowInput] = useState(false);
  const [title, setTitle] = useState('');
  const [settings, setSettings] = useState(defaultSettings);

  useEffect(() => {
    if (loading === false) {
      setTitle('');
      setShowInput(false);
      setSettings(defaultSettings);
    }
  }, [loading]);

  const handleClick = useCallback(() => setShowInput(true), []);

  const handleKeyDown = useCallback(event => {
    if (event.key === 'Escape') {
      setTitle('');
      setShowInput(false);
    }
  }, []);

  const handleSubmit = useCallback(() => {
    onSubmit({ title, settings });
  }, [title, onSubmit, settings]);

  const popupId = useMemo(getPopupId, []);

  return (
    <>
      <div>
        <HelpContentSettingsPopup
          settings={settings}
          onChange={setSettings}
          popupId={popupId}
        />
      </div>
      <ContentButton
        className="AddContentButton"
        onClick={handleClick}
        icon={<PlusIcon className="section-header-icon AddContentButton-plusIcon" />}
      >
        {showInput
          ? (
            <>
              <div className="AddContentButton__inputContainer">
                <Input
                  placeholder="Enter title"
                  value={title}
                  onChange={setTitle}
                  onKeyDown={handleKeyDown}
                  disabled={loading}
                  suffix={
                    loading
                      ? <Spinner small />
                      : (
                        <div className="d-flex">
                          {
                            !hideSettingsIcon && (
                              <div className={POPUP_CALLER_CLASS}>
                                <SettingsIcon size={16} className={classNames(POPUP_CALLER_CLASS)} data-tip="" data-for={popupId}/>
                              </div>
                            )
                          }
                          <SaveIcon size={16} onClick={handleSubmit} className="AddContentButton__saveIcon"/>
                        </div>
                      )
                  }
                />
              </div>
            </>
          )
          : 'Add new'}
      </ContentButton>
    </>

  );
};

AddContentButton.propTypes = {
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  hideSettingsIcon: PropTypes.bool,
};

export default AddContentButton;
